import {
  EtxeApiPrefixes,
  ListPagination,
  PropertyApplicationCreationDto,
  PropertyApplicationDto,
  PropertyApplicationFilterKey,
  PropertyApplicationId,
  PropertyApplicationValuationDto,
  PropertyId,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils';

export class PropertyApplicationsAgentConnector extends ApiConnector<
  PropertyApplicationDto,
  PropertyApplicationDto,
  PropertyApplicationId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string, parentSlug: string) {
    super(apiCaller, apiPrefix, `${parentSlug}/agent`);
  }

  list = (pagination?: ListPagination<PropertyApplicationFilterKey>): Observable<PropertyApplicationDto[]> =>
    this.apiCaller.getRequest<PropertyApplicationDto[]>(
      EtxeApiPrefixes.CORE,
      `${this.slug}${QueryParamsUtils.buildFilterParams(pagination)}`,
    );

  count = (pagination?: ListPagination<PropertyApplicationFilterKey>): Observable<number> =>
    this.apiCaller.getRequest<number>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );

  override get = (applicationId: PropertyApplicationId): Observable<PropertyApplicationDto> =>
    this.apiCaller.getRequest<PropertyApplicationDto>(EtxeApiPrefixes.CORE, `${this.slug}/${applicationId}`);

  forProperty = (propertyId: PropertyId): Observable<PropertyApplicationDto | null> =>
    this.apiCaller.getRequest<PropertyApplicationDto | null>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/property/${propertyId}`,
    );

  apply = (
    propertyId: PropertyId,
    application: PropertyApplicationCreationDto,
  ): Observable<PropertyApplicationDto> =>
    this.apiCaller.postRequest<PropertyApplicationDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/property/${propertyId}`,
      application,
    );

  saveValuation = (
    propertyId: PropertyId,
    valuation: PropertyApplicationValuationDto,
  ): Observable<PropertyApplicationDto> =>
    this.apiCaller.postRequest<PropertyApplicationDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/property/${propertyId}/valuation`,
      valuation,
    );

  submitFinalOffer = (
    propertyId: PropertyId,
    application: PropertyApplicationCreationDto,
  ): Observable<PropertyApplicationDto> =>
    this.apiCaller.postRequest<PropertyApplicationDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/property/${propertyId}/final-offer`,
      application,
    );

  withdraw = (propertyId: PropertyId, reason?: string): Observable<PropertyApplicationDto> =>
    this.apiCaller.postRequest<PropertyApplicationDto>(
      EtxeApiPrefixes.CORE,
      `${this.slug}/property/${propertyId}/withdraw`,
      { reason },
    );
}
